// extracted by mini-css-extract-plugin
export default {"container":"navbar_container__GQst8","info":"navbar_info__BTq0m","burguer":"navbar_burguer__JFrUu","infoOpen":"navbar_infoOpen__yoxIz","burguerOpen":"navbar_burguerOpen__CDg-0"};